import Link from "next/link";
import Image from 'next/image';
import React, { useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";

const HomePageVideoModal = ({videoThumbnail, video}:any) => {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      <img className="banner-video-thumb" src={videoThumbnail} data-toggle="modal" data-target="#banner-video-modal" onClick={() => setModalOpen(!modalOpen)} />

      <Modal id="banner-video-modal" className="modal-dialog-centered sm:mt-[5%] mt-[20%]" toggle={() => setModalOpen(!modalOpen)} isOpen={modalOpen}>
        <div className="modal-header">
          <Button aria-label="Close" className="close close-btn" type="button" onClick={() => setModalOpen(!modalOpen)}>
            <span aria-hidden={true}><Image width={25} height={25} src="/img/close.png" alt="Letter 'x' icon" /></span>
          </Button>
        </div>
        <ModalBody>
          <video controls id="video1" poster={videoThumbnail}>
            <source src={`https://cdn.sanity.io/files/26sxkmoh/production/${video.asset._ref.replace('file-','').replace('-mp4','.mp4')}`} type="video/mp4" />
            Your browser doesn&apos;t support HTML5 video tag.
          </video>
        </ModalBody>
        <ModalFooter className="modal-footer">
        </ModalFooter>
      </Modal>
    </>
  )
}

export default HomePageVideoModal;

